import { queryWithoutParam } from '@insify/funnel-components';
import { ensureDeviceId } from '@insify/ui-utils';
import TagManager from 'react-gtm-module';
import Cookies from 'universal-cookie';

import { isLocalDev } from '../env';

import { getAppDomain } from './localize';

import type { TagManagerArgs } from 'react-gtm-module';

const DEVICE_ID_PARAM = 'device_id';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year

const GTM_IDS = {
  nl: 'GTM-M82HZ3T',
  de: 'GTM-MBVRS38',
  fr: 'GTM-TPXPLKJ',
};

const cookies = new Cookies();

const getRootDomain = (): string => {
  const hostname = window.location.hostname;
  const parts = hostname.split('.').filter(Boolean);
  if (parts.length < 2) return hostname;
  const root = parts.slice(-2).join('.');
  return `.${root}`;
};

const domain = isLocalDev ? undefined : getRootDomain();

const setCookie = (name: string, value: string, maxAge: number) => {
  cookies.set(name, value, {
    path: '/',
    maxAge,
    domain,
    sameSite: 'lax',
  });
};
const getCookie = (name: string) => cookies.get(name);
const deleteCookie = (name: string) => cookies.remove(name);

const setDeviceId = (deviceId?: string | null) => {
  if (!deviceId) return ensureDeviceId(domain);

  setCookie(DEVICE_ID_PARAM, deviceId, COOKIE_MAX_AGE);

  return deviceId;
};

const getDeviceId = () => {
  const existingDeviceId = getCookie(DEVICE_ID_PARAM);
  if (existingDeviceId) return existingDeviceId;

  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);

  const deviceId = params.get(DEVICE_ID_PARAM);

  if (deviceId) {
    const queryWithoutAuth = queryWithoutParam(params, DEVICE_ID_PARAM);
    window.history.replaceState(null, document.title, url.pathname + queryWithoutAuth);
  }

  return setDeviceId(deviceId);
};

const initializeTagManager = () => {
  const country = getAppDomain();
  const tagManagerArgs: TagManagerArgs = {
    gtmId: GTM_IDS[country as keyof typeof GTM_IDS] || 'GTM-NB3H28MR',
  };
  TagManager.initialize(tagManagerArgs);
  // TODO: Optionally, we can send the deviceId to GTM.
  // const deviceId = getDeviceId();
  // if (deviceId) {
  //   TagManager.dataLayer({
  //     dataLayer: {
  //       event: 'deviceIdSet',
  //       deviceId: deviceId,
  //     },
  //   });
  // }
};

export const CookieManager = {
  setDeviceId,
  setCookie,
  getCookie,
  deleteCookie,
};

export const Analytics = {
  getDeviceId,
  setDeviceId,
  initializeTagManager,
};
